import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/fredoka/standard.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/shell.css';
import './styles/footer.css';
import './styles/card.css';
import './styles/card-prestige.css';
import './styles/card-upgrades.css';
import './styles/booster.css';
import './styles/reveal-prestige.css';
import './styles/home.css';
import './styles/collection.css';
import './styles/card-workshop.css';
import './styles/progress.css';
import './styles/public.css';
import './styles/social.css';
import './styles/messaging.css';
import './styles/market.css';
import './styles/harvest.css';
import './styles/login-calendar.css';
import './styles/storefront.css';
import './styles/cosmetics/base.css';
import './styles/cosmetics/frames.css';
import './styles/cosmetics/avatar-fx.css';
import './styles/cosmetics/banner-fx.css';
import './styles/cosmetics/titles.css';
import './styles/cosmetics/badges.css';
import './styles/premium.css';
import './i18n';
import { App } from './App';
import { AutomationGuard } from './components/AutomationGuard';
import { HumanCheckDialog } from './components/HumanCheckDialog';
import { watchTheme } from './hooks/useTheme';
import { watchUiSound } from './hooks/useUiSound';
import { watchAutomation } from './services/automation';
import { listenForInstallPrompt, registerServiceWorker } from './services/pwa';

watchAutomation();
watchTheme();
watchUiSound();
listenForInstallPrompt();
void registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AutomationGuard>
      <App />
      <HumanCheckDialog />
    </AutomationGuard>
  </StrictMode>,
);
